import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { TabPills } from "./TabPills";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _LoanLine } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { Amortizacion } from "../../../../../custom/forpo/components/Credit/Amortizacion";
import useModal, { MODAL_md } from "../../../../../theme/Component/hooks/useModal";

interface Props {
    loanLine: number;
    creditValue?: number;
    creditMonths?: number;
    onChange?: Function;
}


export const SimulatorAmountSelector = ({ loanLine, onChange, creditMonths, creditValue }: Props) => {

    const { bean, setBean, instance } = useDataBean(_LoanLine);

    useEffect(() => {
        if (loanLine && loanLine > 0) {
            instance.getLoanLine(loanLine).then((data: any) => {
                setBean(data);
                setStops([data?.MinimumLoanAmount, data?.MaximumLoanAmount]);
                setJump(data?.QuotaScale ?? 100000);
    
                if (data?.QuotaRange) {
                    const arr = data.QuotaRange.split(',');
                    const _arr = arr.map((e) => ({
                        label: parseInt(e),
                        valor: parseInt(e),
                    }));
    
                    setFeesArray(_arr);
    
                    setBean(prevBean => ({
                        ...prevBean,
                        CreditQuotes: creditMonths ?? _arr[0].valor,
                        CreditValue: creditValue ?? data?.MinimumLoanAmount,
                    }));
                } else {
                    const fallback = [{ label: 3, valor: 3 }];
                    setFeesArray(fallback);
    
                    setBean(prevBean => ({
                        ...prevBean,
                        CreditQuotes: creditMonths ?? fallback[0].valor,
                        CreditValue: creditValue ?? data?.MinimumLoanAmount,
                    }));
                }
            }).catch(err => toast.error(err));
        }
    }, [loanLine, creditValue, creditMonths]); 
    ;

    const modalAmortizacion = useModal("Proyección", MODAL_md);

    const [stops, setStops] = useState([200000, 5000000])
    const [jump, setJump] = useState(100000)
    const [feesArray, setFeesArray] = useState([{ label: 3, valor: 3 }]);

    const Solicitar = () => {
        onChange?.(bean)
    }

    return (
        <div className="row">
            <div className="col-md-12">
                {/* <PrintJson json={props} /> */}
                <div className="row">
                    <div className="col-md-6">
                        <strong>Linea:</strong> {bean.Name} <br />
                    </div>
                    <div className="col-md-6">
                        <strong>Procentaje:</strong> %{bean.CurrentPercentInterest} <br />
                    </div>
                    <div className="col-md-6 d-flex">
                        <strong>Minimo a solicitar :</strong>
                        <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.MinimumLoanAmount, MASK_MONEY) }}></div>
                    </div>
                    <div className="col-md-6 d-flex">
                        <strong>Maximo a solicitar :</strong>
                        <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.MaximumLoanAmount, MASK_MONEY) }}></div>
                    </div>
                    <hr />
                </div>
                <div className="row">
                    <div className="col-12 my-3 d-flex flex-column align-items-center">
                        <strong className='fw-semibold'>
                            <span className='titulres mx-3 fs-5 fst-italic'>Valor a financiar</span>
                            <span className="mx-2 fs-3 text-success" dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.CreditValue, MASK_MONEY) }}>
                            </span>
                        </strong>
                    </div>

                    <div className="mt-3 d-flex flex-column align-items-center justify-content-center gap-2">
                        <small className='mx-auto p-0'>¿Cuál es tu plazo? <span className='text-muted'>(Meses)</span></small>
                        <div>
                            <TabPills defaultValue={creditMonths} lista={feesArray} onSelect={(e) => { setBean({ ...bean, CreditQuotes: e }) }} />
                        </div>
                    </div>

                    <div className="col-12 mt-2 px-5    ">
                        <div className="mb-3">
                            <small className="text-muted animate__animated animate__fadeIn">
                                <small>Desliza aquí para cambiar el valor</small>
                            </small>
                        </div>
                        <input className="rs-range" type="range" value={bean.CreditValue} min={stops[0]} max={stops[1]} step={jump}
                            onChange={(e) => setBean({ ...bean, CreditValue: parseInt(e.target.value) })}
                        />
                        <div className="d-flex justify-content-between">
                            <span className='mt-3' dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(stops[0], MASK_MONEY) }} />
                            <span className='mt-3' dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(stops[1], MASK_MONEY) }} />
                        </div>
                    </div>
                    <div className="col-md-12 mt-4 d-flex justify-content-between">
                        {onChange &&
                            <BasicButton icon="ri-save-line" eventClick={Solicitar}>Guardar</BasicButton>
                        }
                        <BasicButton icon="ri-search-line" eventClick={() => { modalAmortizacion.open() }}>Amortización</BasicButton>
                    </div>
                </div>

                <Modal modal={modalAmortizacion.modal} updateModal={modalAmortizacion.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            <Amortizacion beanRequestCredit={{
                                AmountCredit: bean.CreditValue,
                                AmountTax: bean.CurrentPercentInterest,
                                Cuotes: bean.CreditQuotes
                            }} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
}